import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import DatepickerHeader from '~/components/datepicker-header'
import {
  CAPMPAIGNS_FILTERS_KEYS,
  WALLET_TYPE_OPTIONS
} from '~/modules/retailMedia/store/common/constants'
import { useAppSelector } from '~/store/hooks'
import { setFilter } from '~/store/modules/filters/actions'

import type { WalletBalanceOriginRow } from '../WalletBalanceOrigin/types'
import { WalletOriginFilter } from './WalletOriginFilter'
import { WalletShorelineFilter } from './WalletShorelineFilter'

const WalletTypeFilter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const walletType = useAppSelector(
    state => state.filters.retailMedia.walletType
  )
  const value = Array.isArray(walletType) ? '' : walletType?.value || ''

  return (
    <WalletShorelineFilter
      label={t('rm:wallet.movimentations.filter.type')}
      value={value}
      options={WALLET_TYPE_OPTIONS}
      onChange={next => {
        dispatch(
          setFilter({
            type: CAPMPAIGNS_FILTERS_KEYS.walletType,
            data:
              WALLET_TYPE_OPTIONS.find(option => option.value === next) || null
          })
        )
      }}
    />
  )
}

type WalletTransactionFiltersProps = {
  origins: WalletBalanceOriginRow[]
  originId: string
  onOriginChange: (checkingAccountId: string) => void
  showOriginFilter?: boolean
}

export const WalletTransactionFilters = ({
  origins,
  originId,
  onOriginChange,
  showOriginFilter = true
}: WalletTransactionFiltersProps) => (
  <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
    <WalletTypeFilter />
    {showOriginFilter ? (
      <WalletOriginFilter
        origins={origins}
        value={originId}
        onChange={onOriginChange}
      />
    ) : null}
    <DatepickerHeader />
  </div>
)
